<template>
  <div class="wrapper-template terms-wrap"
       id='sectionContainer'>
    
    <div class="inner-wrapper-one">
      <div class="wrapper-template__inner wrapper-template__inner_flex-col">

        <div class="part">
          <div class="terms-title">
            {{lang.mainTitle}}
          </div>
        </div>

        <div class="part" :key="item.$index"
             v-for="item in lang.parts">
          <p class="text text_b">{{item.title}}</p>

          <ul class="mode-side-list-info-detail__list" v-if="!item.isVsibleAbcd && item.isVisibleList">
            <li class="mode-side-list-info-detail__item"
                :key="listItem.$index"
                v-for="(listItem, index) in item.list">
              <div class="mode-side-list-info-detail__item_flex wrapper-h">
                <span class="num">0{{index + 1}}</span> <div v-html="listItem.item"></div>
              </div>

              <ul class="abcd-list padd-l" v-if="item.haveInnerList">
                <li :key="listItemInner.$index"
                    v-for="listItemInner in listItem.innerlist">
                  <div v-html="listItemInner.item"></div>
                </li>
              </ul>
            </li>
          </ul>

          <ul class="mode-side-list-info-detail__list abcd-list padd-l-14" v-if="item.isVsibleAbcd && item.isVisibleList">
            <li :key="abcd.$index"
                v-for="abcd in item.list">
              <div v-html="abcd.item"></div>
            </li>
          </ul>

          <p class="text" :key="paragraph.$index"
             v-for="paragraph in item.paragraphs"
             v-html="paragraph.text"
             v-if="item.paragraphs && item.paragraphs.length > 0"></p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import switchClasses from '@/util/switcherClasses.js'

export default {
  name: 'CookiePolicy',

  data() {
    return {
      lang: this.$root.$options.LANG.TERMS.termsConditions,
    }
  },

  mounted: function() {
    switchClasses({add: 'show',remove: 'hide'}, 'sectionContainer');
    this.$emit('isNotFound', [{is: true}]);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'terms&etc.scss';

  .mode-side-list-info-detail__item_flex {
    display: flex;
  }

  .mode-side-list-info-detail__item_flex .num {
    font-size: 12px;
  }

  .marg-b-zero {
    margin-bottom:0;
  }
  .padd-l {
    padding-left: 40px;
  }
  .padd-l-14 {
    padding-left: 14px;
  }
</style>
